import type { StripeSettingsQuery} from 'generated/graphql';
import { useStripeSettingsQuery } from 'generated/graphql';
import type { ClientError } from 'graphql-request';
import { graphqlClient } from 'lib/api';
import type { UseQueryOptions } from '@tanstack/react-query';

export default function useStripeSettings(
  variables: { username: string },
  options?: Omit<UseQueryOptions<StripeSettingsQuery, ClientError>, 'queryKey'> & {
    queryKey?: UseQueryOptions<StripeSettingsQuery, ClientError>['queryKey'];
  },
) {
  return useStripeSettingsQuery<StripeSettingsQuery, ClientError>(
    graphqlClient,
    { username: variables.username as never },
    options,
  );
}
